export { MailinglistRecipientsListsContainer as MailinglistRecipients } from './mailinglistRecipients.component';
